import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconDelete = React.memo(
  React.forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
    >
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.25 4C1.25 3.58579 1.58579 3.25 2 3.25L14 3.25C14.4142 3.25 14.75 3.58579 14.75 4C14.75 4.41421 14.4142 4.75 14 4.75L2 4.75C1.58579 4.75 1.25 4.41421 1.25 4Z"
        fill="currentColor"
      />
      <path
        id="Vector_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66671 2.08331C6.512 2.08331 6.36363 2.14477 6.25423 2.25417C6.14483 2.36356 6.08337 2.51194 6.08337 2.66665V3.24998L9.91671 3.24998V2.66665C9.91671 2.51194 9.85525 2.36356 9.74585 2.25417C9.63646 2.14477 9.48808 2.08331 9.33337 2.08331L6.66671 2.08331ZM11.4167 3.24998V2.66665C11.4167 2.11411 11.1972 1.58421 10.8065 1.19351C10.4158 0.802806 9.88591 0.583313 9.33337 0.583313L6.66671 0.583313C6.11417 0.583313 5.58427 0.802806 5.19357 1.19351C4.80287 1.58421 4.58337 2.11411 4.58337 2.66665V3.24998L3.33337 3.24998C2.91916 3.24998 2.58337 3.58577 2.58337 3.99998L2.58337 13.3333C2.58337 13.8858 2.80287 14.4158 3.19357 14.8065C3.58427 15.1972 4.11417 15.4166 4.66671 15.4166L11.3334 15.4166C11.8859 15.4166 12.4158 15.1972 12.8065 14.8065C13.1972 14.4158 13.4167 13.8858 13.4167 13.3333L13.4167 3.99998C13.4167 3.58577 13.0809 3.24998 12.6667 3.24998L11.4167 3.24998ZM4.08337 4.74998L4.08337 13.3333C4.08337 13.488 4.14483 13.6364 4.25423 13.7458C4.36362 13.8552 4.512 13.9166 4.66671 13.9166L11.3334 13.9166C11.4881 13.9166 11.6365 13.8552 11.7459 13.7458C11.8552 13.6364 11.9167 13.488 11.9167 13.3333L11.9167 4.74998L4.08337 4.74998Z"
        fill="currentColor"
      />
    </SvgIcon>
  ))
);

export default IconDelete;
